import { createSelector } from "reselect"
import { get, first, chain, filter } from "lodash"
import { getStartDate, getEndDate } from "./dates"

const EMPTY_OBJECT = {}
const getBetaData = state => get(state, "global.data.compositeBeta.data.model.simulation.beta", EMPTY_OBJECT)

function formatBeta(beta) {
  return chain(beta)
    .map(({ date, predicted, historical }) => {
      return ({
        date,
        factors: {
          predicted,
          historical,
        },
      })
    })
    .filter(data => data)
    .value()
}

export const getBeta = createSelector(
  [getBetaData],
  (absolute) =>
    formatBeta(absolute),
)

export const getFilteredBeta = createSelector(
  [getBeta, getStartDate, getEndDate],
  (beta, startDate, endDate) =>
    filter(beta, (data) => {
      if (data.date >= startDate && data.date <= endDate) {
        return data
      } else {
        return null
      }
    }),
)

export const getFirst = createSelector(
  [getBeta],
  (beta) => first(beta),
)

export const getFirstBetaDate = createSelector(
  [getFilteredBeta],
  (beta) => get(first(beta), "date", null),
)
